import { render, staticRenderFns } from "./EventSubscription.vue?vue&type=template&id=2163b7d8&"
import script from "./EventSubscription.vue?vue&type=script&lang=js&"
export * from "./EventSubscription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports